var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    className: "cls-1",
    d: "M57.6,22.85v-.26a1.67,1.67,0,0,0-.11-.44,2.53,2.53,0,0,0-.18-.37,1.59,1.59,0,0,0-.22-.35l-.36-.31a.81.81,0,0,0-.19-.18l-.25-.11h0a21.91,21.91,0,0,0-20.6-.48,21.91,21.91,0,0,0-20.57.49h0l-.24.1-.2.2-.35.29a1.74,1.74,0,0,0-.22.35,1.56,1.56,0,0,0-.17.37,1.09,1.09,0,0,0,0,.44V51.46a2.94,2.94,0,0,0,0,.42,2,2,0,0,0,.13.41v.13a1.21,1.21,0,0,0,.19.2,2.39,2.39,0,0,0,.29.46l.35.22.37.18a1.09,1.09,0,0,0,.44,0h.81l.42-.16h.13a17.52,17.52,0,0,1,17.52,0h.35a2,2,0,0,0,.73.16h0a2,2,0,0,0,.72-.16h.35a17.54,17.54,0,0,1,17.53,0h.35a2.09,2.09,0,0,0,.74.16h0a2.14,2.14,0,0,0,.75-.16h.17a2,2,0,0,0,.61-.41h0l.33-.42v-.13a1.87,1.87,0,0,0,.13-.42,2.8,2.8,0,0,0,0-.41V51.4ZM18.17,47.91V24.21a17.48,17.48,0,0,1,15.33,0v23.7A21.87,21.87,0,0,0,18.17,47.91Zm19.71,0V24.21a17.5,17.5,0,0,1,15.34,0v23.7A21.89,21.89,0,0,0,37.88,47.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e5f79644de9482603abac370bd7d22ea.svg";
export { ForwardRef as ReactComponent };